import React, { Component } from 'react';

import {
  Paper, withStyles, Grid, IconButton,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import TemplateEditForm from './TemplateEditForm';
import TemplateSummary from './TemplateSummary';

const styles = (theme) => {
  return {
    title: {
      fontWeight: 'bold',
    },
    header: {
      backgroundColor: '#583c5c',
      color: 'white',
    },
    details: {
      display: 'flex',
      margin: theme.spacing(1),
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    editButton: {
      float: 'right',
      backgroundColor: 'white',
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(1.5),
    },
    field: {
      minWidth: '50%',
      textAlign: 'start',
    },
  };
};

class TaskTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editing: false,
      isMouseInside: true,
    };
  }

  setEditing=() => {
    this.setState((prevState) => {
      return { editing: !prevState.editing };
    });
  }

  getLayout=() => {
    const {
      learnExercises, practiceExercises, quizes, assessments, template, videoTypeExercises, videoUrlTypeExercises,
    } = this.props;
    const { classes } = this.props;
    return !this.state.editing
      ? (
        <Paper>
          {this.state.isMouseInside
            ? (
              <Grid container justify="flex-end" alignItems="center">
                <IconButton aria-label="delete" className={classes.editButton} onClick={this.setEditing}>
                  {!this.state.editing ? <EditIcon fontSize="small" />
                    : <CheckCircleOutlineIcon fontSize="default" />}
                </IconButton>
                <IconButton aria-label="delete" className={classes.editButton} onClick={() => { return this.props.setOpenDialog(template._id); }}>
                  {!this.state.editing ? <Delete fontSize="small" />
                    : <CheckCircleOutlineIcon fontSize="default" />}
                </IconButton>
              </Grid>
            ) : null}
          <TemplateSummary template={template} />
        </Paper>
      )
      : (
        <TemplateEditForm
          templateData={template}
          learnExercises={learnExercises}
          videoTypeExercises={videoTypeExercises}
          videoUrlTypeExercises={videoUrlTypeExercises}
          practiceExercises={practiceExercises}
          quizes={quizes}
          assessments={assessments}
          setformOpen={this.setEditing}
          updateData={(data) => { return this.props.updateTaskTemplate(data); }}
        />
      );
  }

  render() {
    return (
      <Grid item xs={this.state.editing ? 12 : 4}>
        {this.getLayout()}
      </Grid>
    );
  }
}

export default withStyles(styles)(TaskTemplate);
